import { Loadable } from '../../Loadable';

export const AsyncAddBrandSplitPaymentMethod = Loadable(() => import('./Add'));
export const AsyncEditBrandSplitPaymentMethod = Loadable(() => import('./Edit'));
export const AsyncBrandSplitPaymentMethodsList = Loadable(() => import('./List'));
